!(function (e) {
  if ("object" == typeof exports && "undefined" != typeof module)
    module.exports = e();
  else if ("function" == typeof define && define.amd) define([], e);
  else {
    ("undefined" != typeof window
      ? window
      : "undefined" != typeof global
      ? global
      : "undefined" != typeof self
      ? self
      : this
    ).EventEmitter3 = e();
  }
})(function () {
  return (function i(s, f, c) {
    function u(t, e) {
      if (!f[t]) {
        if (!s[t]) {
          var n = "function" == typeof require && require;
          if (!e && n) return n(t, !0);
          if (a) return a(t, !0);
          var r = new Error("Cannot find module '" + t + "'");
          throw ((r.code = "MODULE_NOT_FOUND"), r);
        }
        var o = (f[t] = { exports: {} });
        s[t][0].call(
          o.exports,
          function (e) {
            return u(s[t][1][e] || e);
          },
          o,
          o.exports,
          i,
          s,
          f,
          c
        );
      }
      return f[t].exports;
    }
    for (
      var a = "function" == typeof require && require, e = 0;
      e < c.length;
      e++
    )
      u(c[e]);
    return u;
  })(
    {
      1: [
        function (e, t, n) {
          "use strict";
          var r = Object.prototype.hasOwnProperty,
            v = "~";
          function o() {}
          function f(e, t, n) {
            (this.fn = e), (this.context = t), (this.once = n || !1);
          }
          function i(e, t, n, r, o) {
            if ("function" != typeof n)
              throw new TypeError("The listener must be a function");
            var i = new f(n, r || e, o),
              s = v ? v + t : t;
            return (
              e._events[s]
                ? e._events[s].fn
                  ? (e._events[s] = [e._events[s], i])
                  : e._events[s].push(i)
                : ((e._events[s] = i), e._eventsCount++),
              e
            );
          }
          function u(e, t) {
            0 == --e._eventsCount ? (e._events = new o()) : delete e._events[t];
          }
          function s() {
            (this._events = new o()), (this._eventsCount = 0);
          }
          Object.create &&
            ((o.prototype = Object.create(null)),
            new o().__proto__ || (v = !1)),
            (s.prototype.eventNames = function () {
              var e,
                t,
                n = [];
              if (0 === this._eventsCount) return n;
              for (t in (e = this._events))
                r.call(e, t) && n.push(v ? t.slice(1) : t);
              return Object.getOwnPropertySymbols
                ? n.concat(Object.getOwnPropertySymbols(e))
                : n;
            }),
            (s.prototype.listeners = function (e) {
              var t = v ? v + e : e,
                n = this._events[t];
              if (!n) return [];
              if (n.fn) return [n.fn];
              for (var r = 0, o = n.length, i = new Array(o); r < o; r++)
                i[r] = n[r].fn;
              return i;
            }),
            (s.prototype.listenerCount = function (e) {
              var t = v ? v + e : e,
                n = this._events[t];
              return n ? (n.fn ? 1 : n.length) : 0;
            }),
            (s.prototype.emit = function (e, t, n, r, o, i) {
              var s = v ? v + e : e;
              if (!this._events[s]) return !1;
              var f,
                c,
                u = this._events[s],
                a = arguments.length;
              if (u.fn) {
                switch (
                  (u.once && this.removeListener(e, u.fn, void 0, !0), a)
                ) {
                  case 1:
                    return u.fn.call(u.context), !0;
                  case 2:
                    return u.fn.call(u.context, t), !0;
                  case 3:
                    return u.fn.call(u.context, t, n), !0;
                  case 4:
                    return u.fn.call(u.context, t, n, r), !0;
                  case 5:
                    return u.fn.call(u.context, t, n, r, o), !0;
                  case 6:
                    return u.fn.call(u.context, t, n, r, o, i), !0;
                }
                for (c = 1, f = new Array(a - 1); c < a; c++)
                  f[c - 1] = arguments[c];
                u.fn.apply(u.context, f);
              } else {
                var l,
                  p = u.length;
                for (c = 0; c < p; c++)
                  switch (
                    (u[c].once && this.removeListener(e, u[c].fn, void 0, !0),
                    a)
                  ) {
                    case 1:
                      u[c].fn.call(u[c].context);
                      break;
                    case 2:
                      u[c].fn.call(u[c].context, t);
                      break;
                    case 3:
                      u[c].fn.call(u[c].context, t, n);
                      break;
                    case 4:
                      u[c].fn.call(u[c].context, t, n, r);
                      break;
                    default:
                      if (!f)
                        for (l = 1, f = new Array(a - 1); l < a; l++)
                          f[l - 1] = arguments[l];
                      u[c].fn.apply(u[c].context, f);
                  }
              }
              return !0;
            }),
            (s.prototype.on = function (e, t, n) {
              return i(this, e, t, n, !1);
            }),
            (s.prototype.once = function (e, t, n) {
              return i(this, e, t, n, !0);
            }),
            (s.prototype.removeListener = function (e, t, n, r) {
              var o = v ? v + e : e;
              if (!this._events[o]) return this;
              if (!t) return u(this, o), this;
              var i = this._events[o];
              if (i.fn)
                i.fn !== t ||
                  (r && !i.once) ||
                  (n && i.context !== n) ||
                  u(this, o);
              else {
                for (var s = 0, f = [], c = i.length; s < c; s++)
                  (i[s].fn !== t ||
                    (r && !i[s].once) ||
                    (n && i[s].context !== n)) &&
                    f.push(i[s]);
                f.length
                  ? (this._events[o] = 1 === f.length ? f[0] : f)
                  : u(this, o);
              }
              return this;
            }),
            (s.prototype.removeAllListeners = function (e) {
              var t;
              return (
                e
                  ? ((t = v ? v + e : e), this._events[t] && u(this, t))
                  : ((this._events = new o()), (this._eventsCount = 0)),
                this
              );
            }),
            (s.prototype.off = s.prototype.removeListener),
            (s.prototype.addListener = s.prototype.on),
            (s.prefixed = v),
            (s.EventEmitter = s),
            void 0 !== t && (t.exports = s);
        },
        {},
      ],
    },
    {},
    [1]
  )(1);
});

window.theme = window.theme || {};
window.themeInfo = { name: "Drop" };

var Events = new EventEmitter3();
Events.trigger = Events.emit; // trigger alias

/*============================================================================
 Underground Functions
==============================================================================*/
window.WAU = window.WAU || {};

WAU.Slideout = (function () {
  /*
   * Elements
   */
  var wrapper = undefined;

  /*
   * @description - Makes sure that the ESC Key works to close the menus.
   */
  document.addEventListener("keyup", function (event) {
    if (event.key === "Escape") {
      event.preventDefault();
      closeActiveSlideout();
    }
  });

  document.addEventListener("click", function (event) {
    if (event.target === document.querySelector(".js-slideout-overlay")) {
      closeActiveSlideout();
    }
  });

  /*
   * @description - Closes the currently active slide.
   */
  function closeActiveSlideout() {
    // Find the open slideout.
    const activeSlideout = document.querySelector(".slideout--active");
    const activeSlideoutName = activeSlideout.getAttribute("data-wau-slideout");
    const opener = document.querySelector(
      '.js-slideout-open[data-wau-slideout-target="' + activeSlideoutName + '"]'
    );
    const direction = opener.getAttribute("data-slideout-direction");
    const accordionsClosed = activeSlideout.getAttribute(
      "data-wau-accordions-closed"
    );
    if (accordionsClosed !== null) {
      WAU.Accordion.hideAll(activeSlideoutName);
    }

    close(direction, opener);
  }

  /*
   * @description - Checks if the slideout is currently open or not.
   * @return Boolean
   */
  function isOpen() {
    wrapper = document.querySelector(".js-slideout-toggle-wrapper");
    return (
      wrapper.classList.contains("slideout-left--open") ||
      wrapper.classList.contains("slideout-right--open") ||
      wrapper.classList.contains("slideout-up--open")
    );
  }

  /*
   * @description - Open a specific slideout in a specific direction.
   * @param direction:String - the drction to open the slideout in.
   * @param targetSlideoutEl:Node - The slideout element that will be opened.
   */
  function open(direction, targetSlideoutEl, opener) {
    // Close all other active slideouts
    document.querySelectorAll(".slideout--active").forEach((slideout) => {
      if (slideout !== targetSlideoutEl) {
        slideout.classList.remove("slideout--active");
        slideout.classList.add("slideout--close");
        slideout.setAttribute("aria-hidden", "true");
      }
    });

    // Reset aria-expanded on all currently expanded triggers
    document
      .querySelectorAll("[aria-expanded='true']")
      .forEach((trigger) => trigger.setAttribute("aria-expanded", "false"));

    // Hide all close buttons
    document
      .querySelectorAll(".slideout__close--mobile-menu, .slideout__close--cart")
      .forEach((btn) => btn.classList.remove("slideout__close--visible"));

    // Show the close button for the active slideout
    if (targetSlideoutEl.classList.contains("slideout--menu")) {
      const menuCloseBtn = document.querySelector(
        ".slideout__close--mobile-menu"
      );
      if (menuCloseBtn) menuCloseBtn.classList.add("slideout__close--visible");
    } else if (targetSlideoutEl.classList.contains("slideout--cart")) {
      const cartCloseBtn = document.querySelector(".slideout__close--cart");
      if (cartCloseBtn) cartCloseBtn.classList.add("slideout__close--visible");
    }

    // Set aria-expanded on the current opener
    opener.setAttribute("aria-expanded", "true");

    // Optionally hide the menu trigger if this is the menu opener
    const menuTrigger = document.querySelector(
      ".slideout__trigger-mobile-menu"
    );
    if (menuTrigger) {
      if (targetSlideoutEl.classList.contains("slideout--menu")) {
        menuTrigger.classList.add("slideout__trigger--hidden");
      } else {
        menuTrigger.classList.remove("slideout__trigger--hidden");
      }
    }

    // Open the target slideout visually
    wrapper.classList.add(`slideout-${direction}--open`);
    wrapper.classList.remove(`slideout-${direction}--closed`);

    // Lock body scroll
    const scrollPosition = Math.abs(
      0 - document.querySelector(".site-wrap").getBoundingClientRect().top
    );
    wrapper.style.overflow = "hidden";
    wrapper.style.position = "fixed";
    wrapper.style.top = `-${scrollPosition}px`;
    wrapper.style.width = "100%";

    // Trigger slideout-specific events
    const slideoutName = targetSlideoutEl.dataset.wauSlideout;
    Events.trigger(`slideout:open:${slideoutName}`);

    // Make the target slideout accessible
    targetSlideoutEl.setAttribute("aria-hidden", "false");

    // Activate slideout after animation delay
    setTimeout(() => {
      targetSlideoutEl.classList.add("slideout--active");
      targetSlideoutEl.classList.remove("slideout--close");
    }, 350);

    // Trap focus inside the slideout
    trapFocus(targetSlideoutEl);
  }

  /*
   * @description - Closes all slideouts. Puts a11y focus back on the original opener.
   * @param opener:Node - the opener element.
   */
  function close(direction, opener) {
    const activeOpenSlideouts = document.querySelectorAll(".slideout--active");
    const openers = document.querySelectorAll(".js-slideout-open");
    const closers = document.querySelectorAll(".js-slideout-close");

    for (activeOpenSlideout of activeOpenSlideouts) {
      if (activeOpenSlideout.classList.contains("mini-cart--nomaka")) {
        document.querySelector("body").classList.remove("cart-adding");
        document.querySelector("body").classList.remove("cart-add-success");
      }
    }

    // Remove content if quickview
    if (opener && opener.getAttribute("aria-controls") == "quickview") {
      document.querySelector(".js-quickview-content").innerHTML = "";
    }

    // Close the slideout.
    wrapper.classList.remove("slideout-" + direction + "--open");
    wrapper.classList.add("slideout-" + direction + "--closed");

    // Close all active drawers. This is incase there is more than 1 slide on a direction.
    activeOpenSlideouts.forEach(function (activeSlideoutDrawer) {
      const accordionsClosed = activeSlideoutDrawer.getAttribute(
        "data-wau-accordions-closed"
      );
      const activeSlideoutName =
        activeSlideoutDrawer.getAttribute("data-wau-slideout");

      if (accordionsClosed !== null) {
        WAU.Accordion.hideAll(activeSlideoutName);
      }

      Events.trigger("slideout:close:" + activeSlideoutName);

      // Aria and Active classes
      activeSlideoutDrawer.classList.remove("slideout--active");
      activeSlideoutDrawer.classList.add("slideout--close");

      setTimeout(function () {
        activeSlideoutDrawer.setAttribute("aria-hidden", "true");
      }, 350);

      // Remove focus on button
      if (activeSlideoutDrawer.querySelector(".js-slideout-close"))
        activeSlideoutDrawer.querySelector(".js-slideout-close").blur();
    });

    // Makes sure aria-expanded false is added to all the open and close buttons.
    openers.forEach(function (opener) {
      opener.setAttribute("aria-expanded", "false");
    });

    closers.forEach(function (closer) {
      closer.setAttribute("aria-expanded", "false");
    });

    // Fix body wrapper so no scrolling on mobile
    let scrollPosition = Math.abs(
      0 - document.querySelector(".site-wrap").getBoundingClientRect().top
    );

    wrapper.style.removeProperty("overflow");
    wrapper.style.removeProperty("position");
    wrapper.style.removeProperty("top");
    wrapper.style.removeProperty("width");
    window.scrollTo(0, scrollPosition);
  }

  /*
   * @description - Closes a specific slideout given the name in data-wau-slideout attribute
   * @return void
   */
  function closeByName(name) {
    const closer = document.querySelector(
      '[data-wau-slideout-target="' + name + '"]'
    );
    const direction = closer.getAttribute("data-slideout-direction");
    const opener = document.querySelector(
      '.js-slideout-open[data-wau-slideout-target="' + name + '"]'
    );
    close(direction, opener);
  }

  /*
   * @description - Opens a specific slideout given the name in data-wau-slideout attribute
   * @return void
   */
  function openByName(name) {
    const opener = document.querySelector(
      '[data-wau-slideout-target="' + name + '"]'
    );
    const direction = opener
      ? opener.getAttribute("data-slideout-direction")
      : "left";
    const targetSlideoutEl = document.querySelector(
      '[data-wau-slideout="' + name + '"]'
    );
    open(direction, targetSlideoutEl, opener);
  }

  /*
   * @description - Creates a new aside element to be used as a slideout.
   * @param direction:String - the direction that the slideout will open in. "left" or "right"
   * @param name:String - An explicit name to refer to the slideout by on a trigger.
   * @param wrapperEl:Node - An element that can be explicitly passed in as the wrapper element.
   */
  function createSlideoutEl(direction, name, wrapperEl) {
    const aside = document.createElement("aside");
    const innerDiv = document.createElement("div");
    const innerContentDiv = document.createElement("div");
    const opener = document.querySelector(
      '[data-wau-slideout-target="' + name + '"]'
    );
    const content = document.querySelector(
      '[data-wau-slideout-content="' + name + '"]'
    );
    const generatedId = "slideout-" + name;

    wrapperEl = wrapperEl || wrapper;

    if (content.hasAttribute("data-wau-accordions-closed")) {
      aside.setAttribute("data-wau-accordions-closed", "");
    }

    // Create outer wrapper
    aside.classList.add("slideout");
    aside.classList.add("slideout__drawer-" + direction);
    aside.setAttribute("data-wau-slideout", name);
    aside.setAttribute("id", generatedId); // setting an id here so that we can set the aria-controls attribute on the opener.

    // Create inner wrapper and move content to it
    innerDiv.classList.add("slideout__inner-wrapper");
    innerDiv.classList.add("slideout__general-slide__wrapper");
    innerContentDiv.innerHTML = content.innerHTML;
    innerContentDiv.classList.add("slideout__inner-content-container");

    // Empty content so no conflict
    content.innerHTML = "";

    // Add close button to Inner
    if (
      content.dataset.wauSlideoutButton &&
      content.dataset.wauSlideoutButton == "true"
    ) {
      let closeDiv = createCloser(name, direction);
      innerDiv.prepend(closeDiv);
    }

    // Add inner wrapper to outer wrapper
    aside.appendChild(innerDiv);
    innerDiv.appendChild(innerContentDiv);

    opener.setAttribute("aria-controls", generatedId);
    wrapperEl.appendChild(aside);

    return aside;
  }

  /*
   * @description - Empties inner wrapper of slideout and replaces content with previous content
   */
  function reloadSlideoutContents(name) {
    const content = document.querySelector(
      '[data-wau-slideout-content="' + name + '"]'
    );
    const drawer = document.querySelector(
      'aside[data-wau-slideout="' + name + '"]'
    );
    const innerWrapper = drawer.querySelector(
      ".slideout__inner-content-container"
    );

    innerWrapper.innerHTML = content.innerHTML;
  }

  /*
   * @description - Traps keyboard focus inside slideout when open
   */
  function trapFocus(activeSlideout) {
    // add all the elements inside modal which you want to make focusable
    const focusableElements =
      'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const firstFocusableElement =
      activeSlideout.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    const focusableContent = activeSlideout.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

    document.addEventListener("keydown", function (e) {
      let isTabPressed = e.key === "Tab" || e.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus(); // add focus for the last focusable element
          e.preventDefault();
        }
      } else {
        // if tab key is pressed
        if (document.activeElement === lastFocusableElement) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement.focus(); // add focus for the first focusable element
          e.preventDefault();
        }
      }
    });

    firstFocusableElement.focus();
  }
  /*
   * @description - Initializes the plugin by adding all of the appropriate event listeners.
   */
  function init(name) {
    if (typeof name === "undefined") {
      return;
    }

    if (document.querySelector('[data-announcement-bar="true"]')) {
      document.querySelector("body").classList.add("has-announcement-bar");
    }

    wrapper = document.querySelector(".js-slideout-toggle-wrapper");

    const slideoutOpeners = document.querySelectorAll(
      '.js-slideout-open[data-wau-slideout-target="' + name + '"]'
    );

    let slideoutTargetEl = undefined;

    slideoutOpeners.forEach((slideoutOpener, i) => {
      const slideoutDirection = slideoutOpener.getAttribute(
        "data-slideout-direction"
      );

      if (slideoutOpener) {
        slideoutTargetEl = document.querySelector(
          `aside[data-wau-slideout=${name}]`
        );
      }

      if (!slideoutTargetEl) {
        slideoutTargetEl = createSlideoutEl(slideoutDirection, name, wrapper);
      }

      // Set tabindex so it skips hidden slideout

      // Set Aria Hidden on Load
      slideoutTargetEl.setAttribute("aria-hidden", "true");

      // Trigger event for outside functions to listen and use
      Events.trigger("slideout:active:" + name);
      slideoutOpener.addEventListener("click", function () {
        open(slideoutDirection, slideoutTargetEl, slideoutOpener);
      });
    });

    const slideoutClosers = document.querySelectorAll(".js-slideout-close");

    slideoutClosers.forEach((slideoutCloser, i) => {
      const slideoutCloseDirection = slideoutCloser.getAttribute(
        "data-slideout-direction"
      );
      slideoutCloser.addEventListener("click", function () {
        close(slideoutCloseDirection, slideoutCloser);
      });
    });
  }

  const privateFunctions = {
    openByName,
    closeByName,
    createSlideoutEl,
    reloadSlideoutContents,
  };

  let returnObj = {};

  returnObj.init = init;

  /*
   * @description - Gives WAU.Slideout external access to the internal functions for use in Shopify Events.
   */
  Object.keys(privateFunctions).forEach(function (pf) {
    returnObj["_" + pf] = privateFunctions[pf];
  });

  return returnObj;
})();

WAU.Modal = (function () {
  /*
   * Elements
   */
  var wrapper = undefined;
  /*
   * @description - Makes sure that the ESC Key works to close the menus.
   */
  document.addEventListener("keyup", function (event) {
    if (event.key === "Escape") {
      event.preventDefault();
      closeActiveModal();
    }
  });
  document.addEventListener("click", function (event) {
    if (event.target === document.querySelector(".js-modal-overlay")) {
      closeActiveModal();
    }
  });
  /*
   * @description - Closes the currently active modal.
   */
  function closeActiveModal() {
    // Find the open modal.
    const activeModal = document.querySelector(".modal--active");
    const activeModalName = activeModal.getAttribute("data-wau-modal");
    const closer = activeModal.querySelector(".js-modal-close");

    close(closer);
  }
  /*
   * @description - Checks if the modal is currently open or not.
   * @return Boolean
   */
  function isOpen() {
    wrapper = document.querySelector(".js-modal-toggle-wrapper");
    return wrapper.classList.contains("modal--open");
  }
  /*
   * @description - Open a specific modal.
   * @param targetSlideoutEl:Node - The modal element that will be opened.
   */
  function open(targetModalEl, opener) {
    // Fix body wrapper so no scrolling on mobile
    let scrollPosition = Math.abs(
      0 - document.querySelector(".site-wrap").getBoundingClientRect().top
    );
    wrapper.style.width = "100%";

    if (targetModalEl.hasAttribute("data-wau-modal-full")) {
      wrapper.style.overflowY = "hidden";
    } else {
      // Stop from scrolling to top
      targetModalEl.style.top = `calc(${scrollPosition}px + 10vh)`;
    }

    wrapper.classList.add("modal--open");
    wrapper.classList.remove("modal--closed");
    targetModalEl.classList.add("modal--active");

    // Add specific modal type class
    if (targetModalEl.getAttribute("data-wau-modal")) {
      var elClass = targetModalEl.getAttribute("data-wau-modal"),
        elClass = "modal-" + elClass + "--open";
      wrapper.classList.add(elClass);
    }

    opener.setAttribute("aria-expanded", "true");
  }
  /*
   * @description - Closes all modals. Puts a11y focus back on the original opener.
   * @param opener:Node - the opener element.
   */
  function close(openerEl) {
    const activeOpenModals = document.querySelectorAll(".modal--active");
    const openers = document.querySelectorAll(".js-modal-open");
    const closers = document.querySelectorAll(".js-modal-close");

    // Remove content if quickview
    if (openerEl && openerEl.getAttribute("aria-controls") == "quickview") {
      document.querySelector(".js-quickview-content").innerHTML = "";
    }

    // Close the Modal.
    wrapper.classList.remove("modal--open");
    wrapper.classList.add("modal--closed");

    // Close all active modals. This is incase there is more than 1..
    activeOpenModals.forEach(function (activeModalDrawer) {
      // Remove specific modal type class
      if (activeModalDrawer.getAttribute("data-wau-modal")) {
        var elClass = activeModalDrawer.getAttribute("data-wau-modal"),
          elClass = "modal-" + elClass + "--open";
        wrapper.classList.remove(elClass);
      }

      activeModalDrawer.classList.remove("modal--active");

      // For full width modal
      if (activeModalDrawer.hasAttribute("data-wau-modal-full")) {
        wrapper.style.overflowY = "unset";
      }
    });

    // Makes sure aria-expanded false is added to all the open and close buttons.
    openers.forEach(function (opener) {
      opener.setAttribute("aria-expanded", "false");
    });
    closers.forEach(function (closer) {
      closer.setAttribute("aria-expanded", "false");
    });

    // Fix body wrapper so no scrolling on mobile
    wrapper.style.removeProperty("overflow");
    wrapper.style.removeProperty("position");
    wrapper.style.removeProperty("padding-right");
    wrapper.style.removeProperty("top");
    wrapper.style.removeProperty("width");
  }
  /*
   * @description - Closes a specific modal given the name in data-wau-slideout attribute
   * @return void
   */
  function closeByName(name) {
    const closer = document.querySelector(
      '[data-wau-modal-target="' + name + '"]'
    );
    const opener = document.querySelector(
      '.js-modal-open[data-wau-modal-target="' + name + '"]'
    );
    close(opener);
  }
  /*
   * @description - Opens a specific modal given the name in data-wau-slideout attribute
   * @return void
   */
  function openByName(name) {
    const opener = document.querySelector(
      '[data-wau-modal-target="' + name + '"]'
    );
    const targetModalEl = document.querySelector(
      '[data-wau-modal="' + name + '"]'
    );
    open(targetModalEl, opener);
  }
  /*
   * @description - Creates a new close button inside created modal.
   * @param name:String - An explicit name to refer to the modal by on a trigger.
   */
  function createCloser(name) {
    const closeDiv = document.createElement("div");
    const button = document.createElement("button");
    const icon = document.createElement("div");
    closeDiv.classList.add("slideout__trigger--close");
    closeDiv.classList.add("slideout__trigger-" + name + "__wrapper");
    closeDiv.classList.add("slideout__trigger-general-modal__wrapper");
    button.classList.add("slideout__trigger-" + name);
    button.classList.add("slideout__trigger-general-modal");
    button.classList.add("js-modal-close");
    button.setAttribute("aria-controls", "modal-" + name);
    button.setAttribute("aria-label", "Close modal");
    icon.classList.add("icn-close");
    button.appendChild(icon);
    closeDiv.appendChild(button);
    return closeDiv;
  }
  /*
   * @description - Creates a new div element to be used as a modal.
   * @param name:String - An explicit name to refer to the modal by on a trigger.
   * @param wrapperEl:Node - An element that can be explicitly passed in as the wrapper element.
   */
  function createModalEl(name, wrapperEl) {
    const div = document.createElement("div");
    const innerDiv = document.createElement("div");
    const innerContentDiv = document.createElement("div");
    const opener = document.querySelector(
      '[data-wau-modal-target="' + name + '"]'
    );
    const content = document.querySelector(
      '[data-wau-modal-content="' + name + '"]'
    );
    const generatedId = "modal-" + name;
    wrapperEl = wrapperEl || wrapper;

    // Create outer wrapper
    div.classList.add("modal");
    div.classList.add("modal__container");
    div.setAttribute("data-wau-modal", name);
    div.setAttribute("id", generatedId); // setting an id here so that we can set the aria-controls attribute on the opener.

    // Set full width
    if (content && content.hasAttribute("data-wau-modal-full")) {
      div.setAttribute("data-wau-modal-full", "");
    }

    // Create inner wrapper and move content to it
    innerDiv.classList.add("modal__inner-wrapper");
    innerDiv.classList.add("modal__general-modal__wrapper");
    innerContentDiv.innerHTML = content.innerHTML;
    innerContentDiv.classList.add("modal__inner-content-container");

    // Add close button to Inner
    let closeDiv = createCloser(name);
    innerDiv.prepend(closeDiv);

    // Add inner wrapper to outer wrapper
    div.appendChild(innerDiv);
    innerDiv.appendChild(innerContentDiv);
    opener.setAttribute("aria-controls", generatedId);
    wrapperEl.appendChild(div);
    return div;
  }
  /*
   * @description - Initializes the plugin by adding all of the appropriate event listeners.
   */
  function init(name) {
    if (typeof name === "undefined") {
      return;
    }
    wrapper = document.querySelector(".js-modal-toggle-wrapper");
    const modalOpeners = document.querySelectorAll(
      '.js-modal-open[data-wau-modal-target="' + name + '"]'
    );

    let modalTargetEl = undefined;
    if (modalOpeners) {
      modalTargetEl = document.querySelector(`div[data-wau-modal=${name}]`);
    }

    if (!modalTargetEl) {
      modalTargetEl = createModalEl(name, wrapper);
    }

    modalOpeners.forEach((modalOpener, i) => {
      modalOpener.addEventListener("click", function () {
        open(modalTargetEl, modalOpener);
      });
    });

    const modalClosers = document.querySelectorAll(".js-modal-close");
    modalClosers.forEach(function (modalCloser) {
      modalCloser.addEventListener("click", function () {
        close(modalCloser);
      });
    });
  }
  const privateFunctions = {
    openByName,
    closeByName,
    createModalEl,
  };
  let returnObj = {};
  returnObj.init = init;
  /*
   * @description - Gives WAU.Slideout external access to the internal functions for use in Shopify Events.
   */
  Object.keys(privateFunctions).forEach(function (pf) {
    returnObj["_" + pf] = privateFunctions[pf];
  });
  return returnObj;
})();

WAU.Accordion = (function () {
  const classes = {
    show: "is-active",
    open: "js-accordion-is-open",
    mobileNavAccordion: "js-accordion-mobile-nav",
  };

  const selectors = {
    accordion: ".js-accordion",
    accordionItem: ".c-accordion__item",
    accordionLink: ".js-accordion-link",
    accordionHeader: ".js-accordion-header",
    accordionPanel: ".c-accordion__panel",
  };

  const publicAPIs = {};

  /*
   * @description strips class period
   */
  const stripClassPeriod = function (className) {
    if (!className) return;
    return className.split(".")[1];
  };

  /*
   * @description returns class naem
   */
  publicAPIs.getConfigClass = function (className) {
    if (!className) return;
    if (classes[className] && classes[className] != "") {
      return classes[className];
    } else {
      return false;
    }
  };

  /*
   * @description Hides an accordion item
   */
  publicAPIs.hide = function (target) {
    target.setAttribute("aria-expanded", "false");
    target.parentNode.classList.remove("accordion-expanded");

    const panel = document.querySelector(
      `#${target.getAttribute("aria-controls")}`
    );

    panel.setAttribute("hidden", "");

    // 350 matches the CSS transition timing
    setTimeout(function () {
      panel.style.display = "none";
    }, 350);
  };

  /*
   * @description Hides all accordion items at once
   */
  publicAPIs.hideAll = function (name) {
    const accordion = document.querySelector(
      '[data-accordion-family="' + name + '"]'
    );

    if (!accordion) return false;

    const accordionHeaders = document.querySelectorAll(
      '[data-accordion-family="' + name + '"] > .js-accordion-header'
    );

    accordionHeaders.forEach((item, i) => {
      const target = item.querySelector('[data-toggle="accordion"]');

      // Close each accordion item
      target.setAttribute("aria-expanded", "false");
      target.parentNode.classList.remove("accordion-expanded");

      const panel = document.querySelector(
        `#${target.getAttribute("aria-controls")}`
      );

      panel.setAttribute("hidden", "");

      // 350 matches the CSS transition timing
      setTimeout(function () {
        panel.style.display = "none";
      }, 350);
    });
  };

  /*
   * @description Shows an accordion item
   */
  publicAPIs.show = function (target, allowMultiple) {
    const panel = document.querySelector(
      `#${target.getAttribute("aria-controls")}`
    );

    const parentElement = target.closest(panel.getAttribute("data-parent"));

    const allowMultipleFlag =
      allowMultiple ||
      parentElement.hasAttribute("data-accordion-allow-multiple")
        ? true
        : false;

    const isMobileNav = parentElement.classList.contains(
      classes.mobileNavAccordion
    );

    if (!allowMultipleFlag && panel.hasAttribute("data-parent")) {
      let childSelector = "";

      if (isMobileNav) {
        childSelector = ':scope > li > [aria-expanded="true"]';
      } else {
        childSelector = ':scope > [aria-expanded="true"]';
      }

      if (!childSelector) {
        return;
      }

      const activePanels = target
        .closest(panel.getAttribute("data-parent"))
        .querySelectorAll(childSelector);

      if (!activePanels) {
        return;
      }

      activePanels.forEach(function (element) {
        publicAPIs.hide(element);
      });
    }

    target.setAttribute("aria-expanded", "true");
    target.parentNode.classList.add("accordion-expanded");

    panel.removeAttribute("hidden");

    panel.style.display = "block";
  };

  /*
   * @description Toggle showing and hiding an accordion item
   */
  publicAPIs.toggle = function (target, allowMultiple) {
    if (target.getAttribute("aria-expanded") == "true") {
      publicAPIs.hide(target);
      return;
    } else {
      publicAPIs.show(target, allowMultiple);
    }
  };

  /*
   * @description Initialize function
   */
  publicAPIs.init = function () {
    // Hide add accordion panels
    document
      .querySelectorAll(`[data-toggle="accordion"]:not(.${classes.open})`)
      .forEach(function (element, index) {
        publicAPIs.hide(element);
      });

    // Add keyboard accessibility events
    document.addEventListener("keydown", function (event) {
      let target = event.target;
      const key = event.which.toString();
      const disablePageScroll = false;
      const pageScrollOptions = disablePageScroll
        ? { preventScroll: true }
        : { preventScroll: false };
      const isDropDownArrow = target.classList.contains("dropdown-arrow");

      if (
        target.classList.contains(
          stripClassPeriod(selectors.accordionHeader)
        ) ||
        target.classList.contains(stripClassPeriod(selectors.accordionLink)) ||
        isDropDownArrow
      ) {
        if (key.match(/38|40/)) {
          const isMobile = target
            .closest(selectors.accordion)
            .classList.contains(classes.mobileNavAccordion)
            ? true
            : false;

          const accordionSelector = isMobile
            ? `:scope > li > ${selectors.accordionLink}`
            : `:scope > ${selectors.accordionHeader}`;

          const accordions = target
            .closest(selectors.accordion)
            .querySelectorAll(accordionSelector);

          if (isMobile && isDropDownArrow) {
            target.previousElementSibling.focus(pageScrollOptions);
            return;
          }

          let indexPlace;
          accordions.forEach(function (element, index) {
            if (element == target) {
              indexPlace = index;
            }
          });
          const direction = key.match(/34|40/) ? 1 : -1;
          const length = accordions.length;
          const newIndex = (indexPlace + length + direction) % length;

          accordions[newIndex].focus(pageScrollOptions);
        }
      }
    });

    document.addEventListener("click", function (event) {
      const target = event.target.matches('[data-toggle="accordion"]')
        ? event.target
        : event.target.closest('[data-toggle="accordion"]');

      if (!target) {
        return false;
      }

      event.preventDefault();

      publicAPIs.toggle(target);
    });

    document.addEventListener("click", function (event) {
      if (event.target.classList.contains("js-accordion-link")) {
        let url = event.target.getAttribute("href");
        if (url == "") {
          event.preventDefault();

          let target = event.target.parentNode.querySelector(
            '[data-toggle="accordion"]'
          );
          publicAPIs.toggle(target);
        }
      }
    });
  };

  return publicAPIs;
})();

WAU.Helpers = (function () {
  var touchDevice = false;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function makeSticky(amountToScroll, elementClass, elementHeight) {
    const clearElement = document.querySelector(".js-clear-element"),
      stickyElement = document.querySelector(elementClass);

    if (
      clearElement.classList.contains("over-content--true") &&
      window.matchMedia("(min-width: 968px)").matches
    ) {
      height = "0px";
    } else {
      height = elementHeight + "px";
    }

    if (window.pageYOffset > amountToScroll) {
      stickyElement.classList.add("sticky--active");
      clearElement.style.height = height;
    } else {
      stickyElement.classList.remove("sticky--active");
      clearElement.style.height = "0px";
    }
  }

  function showHide(show, hide) {
    var show = document.getElementById(show);
    show.classList.remove("hide");
    show.classList.add("show");
    show.style.display = "block";

    var hide = document.getElementById(hide);
    hide.classList.remove("show");
    hide.classList.add("hide");
    hide.style.display = "none";
  }

  function Toggle(id) {
    var element = document.getElementById(id);
    if (element.classList.contains("animate-hide")) {
      element.classList.remove("animate-hide", "fadeOut");
      element.classList.add("animate-show", "fadeIn");
      element.style.visibility = "visible";
    } else {
      element.classList.remove("animate-show", "fadeIn");
      element.classList.add("animate-hide", "fadeOut");
      element.style.visibility = "hidden";
    }
  }

  function toggleClass(id, className) {
    var element = document.getElementById(id);
    if (!element) return false;
    if (element.classList.contains(className)) {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  }

  function Accordion(container, tlink, submenu) {
    let accorContent = container.querySelector(submenu);

    if (!container.querySelector(tlink)) return false;

    container.querySelector(tlink).addEventListener("click", function (event) {
      event.preventDefault();

      // Toggle class on label and update a11y
      if (this.classList.contains("closed")) {
        this.classList.remove("closed");
        this.parentElement.classList.remove("closed");
        this.setAttribute("aria-expanded", "true");
      } else {
        this.classList.add("closed");
        this.parentElement.classList.add("closed");
        this.setAttribute("aria-expanded", "false");
      }

      // Show content
      if (accorContent.classList.contains("closed")) {
        accorContent.classList.remove("closed");
        accorContent.style.display = "block";
      } else {
        accorContent.classList.add("closed");
        accorContent.style.display = "none";
      }
    });
  }

  function fadeToggle(el, display) {
    var style = display || "block";

    if (el.style.display === "none") {
      el.style.opacity = 0;
      el.style.display = display || "block";

      (function fade() {
        var val = parseFloat(el.style.opacity);
        if (!((val += 0.1) > 1)) {
          el.style.opacity = val;
          requestAnimationFrame(fade);
        }
      })();
    } else if (el.style.display === style) {
      el.style.opacity = 1;

      (function fade() {
        if ((el.style.opacity -= 0.1) < 0) {
          el.style.display = "none";
        } else {
          requestAnimationFrame(fade);
        }
      })();
    }
  }

  function fadeOut(el) {
    el.style.opacity = 1;

    (function fade() {
      if ((el.style.opacity -= 0.1) < 0) {
        el.style.display = "none";
      } else {
        requestAnimationFrame(fade);
      }
    })();
  }

  function fadeIn(el, display) {
    el.style.opacity = 0;
    el.style.display = display || "block";

    (function fade() {
      var val = parseFloat(el.style.opacity);
      if (!((val += 0.1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      }
    })();
  }

  function getScrollbarWidth() {
    // Creating invisible container
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll"; // forcing scrollbar to appear
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement("div");
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
  }

  function smoothScrollTo(endX, endY, duration) {
    let startX = window.scrollX || window.pageXOffset,
      startY = window.scrollY || window.pageYOffset,
      distanceX = endX - startX,
      distanceY = endY - startY,
      startTime = new Date().getTime();
    // Easing function
    let easeInOutQuart = function (time, from, distance, duration) {
      if ((time /= duration / 2) < 1)
        return (distance / 2) * time * time * time * time + from;
      return (-distance / 2) * ((time -= 2) * time * time * time - 2) + from;
    };
    let timer = window.setInterval(function () {
      let time = new Date().getTime() - startTime,
        newX = easeInOutQuart(time, startX, distanceX, duration),
        newY = easeInOutQuart(time, startY, distanceY, duration);
      if (time >= duration) {
        window.clearInterval(timer);
      }
      window.scrollTo(newX, newY);
    }, 1000 / 60); // 60 fps
  }

  function wrapIframe(options) {
    options.iframes.forEach(function (iframe) {
      var wrapper = document.createElement("div");
      wrapper.classList.add(options.iframeWrapperClass);

      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);

      iframe.src = iframe.src;
    });
  }

  function wrapTable(options) {
    options.tables.forEach(function (table) {
      var wrapper = document.createElement("div");
      wrapper.classList.add(options.tableWrapperClass);

      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  function scriptLoader() {
    /**
     * Promise-based script loader
     * @param {string} url
     * @param {object=} attr
     * @returns {Promise}
     */
    const loader = (url, attr) =>
      new Promise((resolve, reject) => {
        const script = window.document.createElement("script");
        script.src = url;
        script.async = true;
        script.crossOrigin = "anonymous";

        attr = attr || {};

        for (const attrName in attr) {
          script[attrName] = attr[attrName];
        }

        script.addEventListener(
          "load",
          () => {
            resolve(script);
          },
          false
        );

        script.addEventListener(
          "error",
          () => {
            reject(script);
          },
          false
        );

        function scriptExists(url) {
          return document.querySelectorAll(`script[src="${url}"]`).length > 0;
        }

        if (!scriptExists(url)) {
          window.document.head.appendChild(script);
        } else {
          resolve(script);
        }
      });

    /**
     * Loads scripts asynchronously
     * @param {string|string[]} urls
     * @param {object=} attr Other script tag attributes
     * @returns {Promise}
     */
    this.load = (urls, attr) => {
      if (!Array.isArray(urls)) {
        urls = [urls];
      }

      return Promise.all(urls.map((url) => loader(url, attr)));
    };

    /**
     * Loads scripts asynchronously. It supports multiple url arguments, so each one will be loaded right after the
     * previous is loaded. This is a way of chaining dependency loading.
     *
     * @param {string|string[]} urls, ...
     * @returns {Promise}
     */
    this.loadChain = function (urls) {
      const args = Array.isArray(arguments)
        ? arguments
        : Array.prototype.slice.call(arguments);
      const p = this.require(args.shift());
      const self = this;
      return args.length
        ? p.then(() => {
            self.requireChain(...args);
          })
        : p;
    };
  }

  function scriptExists(url) {
    return document.querySelectorAll(`script[src="${url}"]`).length > 0;
  }

  function isElementPastEdge(element) {
    const bounding = element.getBoundingClientRect(),
      l = bounding.left,
      w = bounding.width,
      docH = document.documentElement.clientHeight,
      docW = document.documentElement.clientWidth;

    return l + w >= docW;
  }

  function formatMoney(cents, format) {
    const moneyFormat = "${{amount}}";

    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ",",
      decimal = "."
    ) {
      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    debounce: debounce,
    makeSticky: makeSticky,
    showHide: showHide,
    Toggle: Toggle,
    toggleClass: toggleClass,
    Accordion: Accordion,
    fadeToggle: fadeToggle,
    fadeOut: fadeOut,
    fadeIn: fadeIn,
    getScrollbarWidth: getScrollbarWidth,
    smoothScrollTo: smoothScrollTo,
    wrapIframe: wrapIframe,
    wrapTable: wrapTable,
    scriptLoader: scriptLoader,
    scriptExists: scriptExists,
    isElementPastEdge: isElementPastEdge,
    formatMoney: formatMoney,
  };
})();

WAU.a11yHelpers = (function () {
  let alreadySetUpKeyEvents = false;

  /*
   * @description - Sets up the aria-expanded property to true and false on hover.
   */
  function setUpAriaExpansion() {
    const ariaExpandEls = document.querySelectorAll(".js-aria-expand");

    ariaExpandEls.forEach(function (ariaExpandEl) {
      ariaExpandEl.addEventListener("mouseover", function (event) {
        ariaExpandEl.setAttribute("aria-expanded", "true");
      });

      ariaExpandEl.addEventListener("mouseout", function (event) {
        ariaExpandEl.setAttribute("aria-expanded", "false");
      });
    });
  }

  /*
   * @description - Takes a parent element and focuses on the next focusable element inside of there.
   */
  function focusOnElement(parent) {
    var focussableElements =
      'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';

    const elementToFocusOn = parent.querySelector(focussableElements);

    if (elementToFocusOn) {
      elementToFocusOn.focus();
    }
  }

  function findFocusableElement(parent, element, direction) {
    const focusableElementSelectors =
      'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
    const focusableElements = parent.querySelectorAll(
      focusableElementSelectors
    );
    const numOfFocusableElements = focusableElements.length;

    var elementIndex = 0;

    for (let i = 0; i < focusableElements.length; i += 1) {
      let currentElement = focusableElements[i];

      if (currentElement === element) {
        elementIndex = i;
      }
    }

    if (direction === "next") {
      if (elementIndex === numOfFocusableElements - 1) {
        return focusableElements[0];
      } else {
        return focusableElements[elementIndex + 1];
      }
    }

    if (direction === "prev") {
      if (elementIndex === 0) {
        return focusableElements[numOfFocusableElements - 1];
      } else {
        return focusableElements[elementIndex - 1];
      }
    }
  }

  /*
   * @description - Takes a parent and a dom node and returns the next element that is focusable that is not the current element.
   * @param parent:DOMNode
   * @param element:DOMNode
   * @return DOMNode
   */
  function findNextFocusableElement(parent, element) {
    return findFocusableElement(parent, element, "next");
  }

  function findPreviousFocusableElement(parent, element) {
    return findFocusableElement(parent, element, "prev");
  }

  /*
   * @description - Enables accessible keyboard navigation throughout the navigation menus.
   */
  function setUpAccessibleNavigationMenus() {
    function closeDropdownMenus() {
      const activeMenuItems = document.querySelectorAll(
        ".navigation__menuitem--active"
      );
      activeMenuItems.forEach(function (activeMenuItem) {
        activeMenuItem.classList.remove("navigation__menuitem--active");
        activeMenuItem.setAttribute("aria-expanded", "false");
      });
    }

    function closeNestedDropdownMenus() {
      //remove the class that makes the dropdown show... the active class
      const nestedDropdowns = document.querySelectorAll(
        ".js-menuitem-with-nested-dropdown"
      );

      nestedDropdowns.forEach(function (nestedDropdown) {
        nestedDropdown.classList.remove("dropdown__menuitem--active");
        nestedDropdown.setAttribute("aria-expanded", "false");
      });
    }

    function addEdgeToDropdown(dropdown) {
      setTimeout(function () {
        if (WAU.Helpers.isElementPastEdge(dropdown)) {
          dropdown.classList.add("dropdown--edge");
        } else {
          dropdown.classList.remove("dropdown--edge");
        }
      }, 0);
    }

    if (!alreadySetUpKeyEvents) {
      document.addEventListener("keyup", function (event) {
        if (event.key === "Escape") {
          const openNestedDropdownMenus = document.querySelectorAll(
              ".dropdown__menuitem--active"
            ),
            openDropdownMenus = document.querySelectorAll(
              ".navigation__menuitem--active"
            );

          event.preventDefault();

          if (openNestedDropdownMenus.length >= 1) {
            closeNestedDropdownMenus();
            return;
          }

          if (openDropdownMenus.length >= 1) {
            closeDropdownMenus();
            return;
          }
        }
      });
    }

    if (!alreadySetUpKeyEvents) {
      document.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          if (
            document.activeElement.classList.contains(
              "js-open-dropdown-on-key"
            ) ||
            document.activeElement.parentNode.classList.contains(
              "js-menuitem-with-nested-dropdown"
            )
          ) {
            event.stopPropagation();
            event.preventDefault();
          }

          if (
            document.activeElement.parentNode.classList.contains(
              "navigation__menuitem--active"
            )
          ) {
            closeDropdownMenus();
            return;
          }

          if (
            document.activeElement.parentNode.classList.contains(
              "dropdown__menuitem--active"
            )
          ) {
            closeNestedDropdownMenus();
            return;
          }

          if (
            document.activeElement.parentNode.classList.contains(
              "js-first-level"
            )
          ) {
            closeDropdownMenus();
          }

          if (
            document.activeElement.classList.contains("js-open-dropdown-on-key")
          ) {
            document.activeElement.parentNode.classList.add(
              "navigation__menuitem--active"
            ); // Show the menu by adding the appropriate class.
            return;
          }

          if (
            document.activeElement.parentNode.classList.contains(
              "js-menuitem-with-nested-dropdown"
            )
          ) {
            document.activeElement.parentNode.classList.add(
              "dropdown__menuitem--active"
            );
            addEdgeToDropdown(document.activeElement.parentNode);
            return;
          }
        }
      });
    }

    alreadySetUpKeyEvents = true;
  }

  return {
    setUpAriaExpansion: setUpAriaExpansion,
    setUpAccessibleNavigationMenus: setUpAccessibleNavigationMenus,
    focusOnElement: focusOnElement,
  };
})();

WAU.Sections = (function () {
  document
    .querySelectorAll("[data-section-type]")
    .forEach(function (container) {
      let callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadAssets(container);
            if (container.hasAttribute("data-section-loaded")) {
              container.setAttribute("data-section-loaded", "true");
            }
          }
        });
      };

      let observer = new IntersectionObserver(callback);
      observer.observe(container);

      function loadAssets(container) {
        // Load section assets
        if (container.dataset.assetUrl) {
          const loader = new WAU.Helpers.scriptLoader();
          loader.load([container.dataset.assetUrl]).then(({ length }) => {});
        }
      }

      document.addEventListener("shopify:section:select", function (event) {
        if (container.dataset.sectionId == event.detail.sectionId) {
          if (container.hasAttribute("data-section-loaded")) {
            event.target.classList.add("section--reloaded");
          }
        }
      });
      document.addEventListener("shopify:section:load", function (event) {
        loadAssets(event.target.querySelector("[data-section-type]"));
        event.target.classList.add("section--reloaded");
      });
    });
})();

WAU.ProductGridVideo = {
  init: function init() {
    if (!HTMLMediaElement.hasOwnProperty("playing")) {
      Object.defineProperty(HTMLMediaElement.prototype, "playing", {
        get: function () {
          return !!(
            this.currentTime > 0 &&
            !this.paused &&
            !this.ended &&
            this.readyState > 2
          );
        },
      });
    }
    document
      .querySelectorAll(".js-bg-video-wrapper")
      .forEach(function (element) {
        WAU.ProductGridVideo.initVideo(element);
      });
  },
  initVideo: function initVideo(element) {
    var selectorId = element.dataset.productId,
      videoUrl = element.dataset.videoUrl,
      selector = ".js-bg-video-" + selectorId;

    const wrapper = element.querySelector(selector);
    const video = element.querySelector("video");

    // Set CSS
    video.style.opacity = 1;
    video.width = wrapper.offsetWidth;
    wrapper.style.zIndex = 1;
    wrapper.style.position = "relative";

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!entry.target.playing) {
            entry.target.play();
          }
        }
      });
    });
    observer.observe(video);
  },
  destroyVideo: function destroyVideo(element) {
    element.destroy();
  },
  reinitVideo: function reinitVideo(selector, options) {
    var instance = new vidbg(selector, options);
    return instance;
  },
};

WAU.LocalizationForm = function (container) {
  function init() {
    container.querySelector("button").addEventListener("click", openSelector);
    container
      .querySelector("button")
      .addEventListener("focusout", closeSelector);
    container.addEventListener("keyup", onContainerKeyUp);
    container
      .querySelectorAll("a")
      .forEach((item) => item.addEventListener("click", onItemClick));
  }
  function hidePanel() {
    container.querySelector("button").setAttribute("aria-expanded", "false");
    container
      .querySelector(".disclosure__list-container")
      .setAttribute("hidden", true);
  }
  function onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    hidePanel();
    container.querySelector("button").focus();
  }
  function onItemClick(event) {
    event.preventDefault();
    const form = container.querySelector("form");
    container.querySelector(
      'input[name="locale_code"], input[name="country_code"]'
    ).value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
  function openSelector() {
    container.querySelector("button").focus();
    container
      .querySelector(".disclosure__list-container")
      .toggleAttribute("hidden");
    container
      .querySelector("button")
      .setAttribute(
        "aria-expanded",
        (
          container.querySelector("button").getAttribute("aria-expanded") ===
          "false"
        ).toString()
      );
  }
  function closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      hidePanel();
    }
  }

  return init();
};

WAU.mobileSearch = function () {
  const mobileSearchElem = document.querySelector(".js--mobile-search");

  if (!mobileSearchElem) return;

  function updateAriaHidden() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) {
      mobileSearchElem.setAttribute("aria-hidden", "false");
    } else {
      mobileSearchElem.setAttribute("aria-hidden", "true");
    }
  }

  document.addEventListener("DOMContentLoaded", updateAriaHidden);

  window.addEventListener("resize", updateAriaHidden);
};

WAU.mobileSearch();

/*============================================================================
 Shopify Common
==============================================================================*/

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/*============================================================================
  Global Events & Helpers
==============================================================================*/
(function WAUInits() {
  WAU.Accordion.init();
  WAU.Slideout.init("mobile-navigation");

  document
    .querySelectorAll("[data-localization-form]")
    .forEach(function (container) {
      WAU.LocalizationForm(container);
    });

  document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelectorAll(".js-bg-video-wrapper")) {
      WAU.ProductGridVideo.init();
    }
  });

  document.addEventListener("shopify:section:select", function (event) {
    if (document.querySelectorAll(".js-bg-video-wrapper")) {
      WAU.ProductGridVideo.init();
    }
    if (event.target.querySelector("[data-localization-form]")) {
      WAU.LocalizationForm(
        event.target.querySelector("[data-localization-form]")
      );
    }
    // Reinitialize accessibility helpers when a section is loaded
    WAU.a11yHelpers.setUpAccessibleNavigationMenus();
    WAU.a11yHelpers.setUpAriaExpansion();
  });

  document.addEventListener("shopify:section:load", function (event) {
    // Reinitialize accessibility helpers when a section is loaded
    WAU.a11yHelpers.setUpAccessibleNavigationMenus();
    WAU.a11yHelpers.setUpAriaExpansion();
    const localizationForms = event.target.querySelectorAll(
      "[data-localization-form]"
    );
    if (localizationForms.length > 0) {
      localizationForms.forEach(function (form) {
        WAU.LocalizationForm(form);
      });
    }
  });

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    if (!sessionStorage.getItem("beaconSent")) {
      try {
        const url = "https://api.weareunderground.com/beacon";

        const themeName = Shopify.theme?.name || "Unknown";
        const themeVersion = Shopify.theme?.schema_version || "Unknown";

        const params = new URLSearchParams({
          shop: window.Shopify.shop,
          themeName: `${themeName} v${themeVersion}`,
          role: window.Shopify.theme.role,
          route: window.location.pathname,
          themeId: window.Shopify.theme.id,
          themeStoreId: window.Shopify.theme.theme_store_id || 0,
          isThemeEditor: !!window.Shopify.designMode,
        });

        if (!navigator.sendBeacon(url, params)) {
          fetch(url, { method: "POST", body: params }).catch(() => {});
        }
        sessionStorage.setItem("beaconSent", "true");
      } catch (error) {
        // errors will be silently ignored.
      }
    }
  }
})();

(function helperRteFormat() {
  WAU.Helpers.wrapIframe({
    iframes: document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]'),
    iframeWrapperClass: "video-wrapper",
  });

  WAU.Helpers.wrapIframe({
    iframes: document.querySelectorAll('.rte iframe[src*="player.vimeo"]'),
    iframeWrapperClass: "video-wrapper",
  });

  WAU.Helpers.wrapTable({
    tables: document.querySelectorAll(".rte table"),
    tableWrapperClass: "table-wrapper",
  });
})();

(function helperThemeVersion() {
  /* Log Theme Version */
  log = function () {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(console);
    return Function.prototype.bind.apply(console.log, args);
  };

  log("Drop Version 5.0.0 by Underground", { bar: 1 })();
})();

(function helperNotifyForm() {
  var notifySubmitBtns = document.querySelectorAll(".js-notify-submit");
  notifySubmitBtns.forEach(function (btn) {
    btn.addEventListener("click", function (event) {
      event.preventDefault();
      var prod = event.target.dataset.productId;
      var currentUrl = window.location.href;
      var form = btn.closest("form");

      submitForm(form, currentUrl, prod);
    });
  });
  let notifySubmitForms = document.querySelectorAll(".js-notify-contact-form");
  notifySubmitForms.forEach(function (form) {
    var prodId = sessionStorage.getItem("form_product");

    if (form.id == prodId) {
      // Show success msg
      form.querySelector(".notify-form__success-wrapper").style.display =
        "block";
      // Hide subscribe form
      form.querySelector(".notify-form__subscribe-wrapper").style.display =
        "none";
      // Hide form toggle btn
      if (form.parentNode.previousSibling) {
        form.parentNode.previousSibling.style.display = "none";
      }
    } else {
      form.querySelector(".notify-form__success-wrapper").style.display =
        "none";
      form.querySelector(".notify-form__subscribe-wrapper").style.display =
        "block";
    }
  });

  if (
    window.location.href.indexOf("collections") > -1 &&
    window.location.href.indexOf("contact_posted") > -1 &&
    sessionStorage.getItem("prev_url") !== null
  ) {
    window.location.href = sessionStorage.getItem("prev_url");
  }

  function submitForm(form, currentUrl, prod) {
    // Check if valid using HTML5 checkValidity() builtin function
    if (form.checkValidity()) {
      storeData(currentUrl, prod);
      form.submit();
    } else {
      var errorMsg = form.querySelector(".js-form-error");
      WAU.Helpers.fadeIn(errorMsg, "block");
      setTimeout(function () {
        WAU.Helpers.fadeOut(errorMsg);
      }, 2000);
    }

    return false;
  }

  function storeData(currentUrl, prod) {
    sessionStorage.setItem("prev_url", currentUrl);
    sessionStorage.setItem("form_product", prod);
  }
})();

(function initModals() {
  if (document.querySelector('[data-wau-modal="new-address"]')) {
    WAU.Modal.init("new-address");
  }

  var buildModals = document.querySelectorAll("[data-wau-modal-content]");
  if (buildModals) {
    buildModals.forEach((item, i) => {
      var contentType = item.dataset.wauModalContent;
    });
  }

  var modals = document.querySelectorAll("[data-wau-modal]");
  if (modals) {
    modals.forEach((item, i) => {
      if (item.dataset.wauModal.includes("edit-address")) {
        WAU.Modal.init(item.dataset.wauModal);
      }
    });
  }
})();

// (function formValidation() {
//   /* Form Validation */
//   var validateForm = function (submitEvent) {
//     if (!submitEvent.target.checkValidity()) {
//       submitEvent.preventDefault();
//       submitEvent.stopImmediatePropagation();
//       submitEvent.stopPropagation();

//       var form = submitEvent.target,
//         elements = form.elements;

//       for (var index = 0, len = elements.length; index < len; index++) {
//         var element = elements[index];
//         if (element.willValidate === true && element.validity.valid !== true) {
//           var message = element.validationMessage,
//             parent = element.parentNode,
//             div = document.createElement("small");

//           div.appendChild(document.createTextNode(message));
//           div.classList.add("validation-message");

//           parent.insertBefore(div, element.nextSibling);

//           element.focus();
//           break;
//         }
//       }
//     } else {
//       return true;
//     }
//   };

//   document.addEventListener("DOMContentLoaded", function () {
//     var forms = document.querySelectorAll("form");

//     for (var index = forms.length - 1; index >= 0; index--) {
//       var form = forms[index];

//       if (form.classList.contains("js-no-validate")) return false;
//       form.noValidate = true;
//       form.addEventListener("submit", validateForm);
//     }
//   });
// })();

const ViewedProducts = (function () {
  let Constructor = function (params) {
    const publicAPIs = {};

    // default configs
    var config = {
      howManyToShow: 3,
      howManyToStoreInMemory: 30,
      wrapperId: "recently-viewed-products",
      onComplete: null,
    };

    // array containing recently viewed products
    var productHandleQueue = [];

    // wrapper element that displays the products
    var wrapper = null;

    // variable to keep track of how many products have been shown
    var shown = 0;

    // Handle cookie related operations
    var cookie = {
      configuration: {
        expires: 90,
        path: "/",
        domain: window.location.hostname,
        sameSite: "none",
        secure: true,
      },
      name: "shopify_recently_viewed",
      write: function (recentlyViewed) {
        Cookies.set(this.name, recentlyViewed.join(" "), this.configuration);
      },
      read: function () {
        var recentlyViewed = [];
        var cookieValue = Cookies.get(this.name);
        if (cookieValue !== undefined && cookieValue !== "") {
          recentlyViewed = cookieValue.split(" ");
        }
        return recentlyViewed;
      },
      destroy: function () {
        Cookies.remove(this.name, null, this.configuration);
      },
      remove: function (productHandle) {
        var recentlyViewed = this.read();
        var position = recentlyViewed.indexOf(productHandle);
        if (position !== -1) {
          recentlyViewed.splice(position, 1);
          this.write(recentlyViewed);
        }
      },
    };

    // Reveal wrapper element and show recently viewed products and run call back if provided one.
    var finalize = function () {
      // Check if any products were shown.
      if (shown > 0) {
        // Remove hidden class if it exists
        if (wrapper.classList.contains("recently-viewed-products--hidden")) {
          wrapper.classList.remove("recently-viewed-products--hidden");
        }

        // If we have a callback.
        if (config.onComplete) {
          try {
            config.onComplete();
          } catch (error) {}
        }
      } else {
        return false;
      }
    };

    // Format the product listing template by converting it into a DOM node, determining it's CSS grid classes and then wrapping it with those classes
    var formatTemplate = (product) => {
      // Check if the product data was passed
      if (!product) {
        console.log(
          "Error. Must provide a valid product in order to format it"
        );
        return false;
      }

      //
      // Convert the product into a node.
      //

      // Parse the product HTML into a DOM node.
      var parser = new DOMParser();
      var doc = parser.parseFromString(product, "text/html");

      // Get the template element.
      var template = doc.querySelector('[data-html="listing"]');

      // Check if we have a valid template element.
      if (!template) {
        return false;
      }

      //
      // Wrap the product in a div with grid classes.
      //

      // Create div element
      let productWrap = document.createElement("div");

      // Apply classes
      productWrap.classList.add(
        "product",
        "product-loop__item",
        "relative",
        "recently-viewed-products__product",
        "js-product-listing",
        "product-loop__item--vertical"
      );

      // Append product in wrapper element
      productWrap.appendChild(template.content);

      // Return the final product template
      return productWrap;
    };

    // Use fetch api to get product data and add it to the list
    var moveAlong = function () {
      if (productHandleQueue.length && shown < config.howManyToShow) {
        // Build fetch url
        let furl = `${window.Shopify.routes.root}products/${productHandleQueue[0]}?view=listing`;

        // Fetch the product data
        fetch(furl)
          .then((response) => {
            // Convert data to text
            return response.text();
          })
          .then((response) => {
            // Get the formated product node with the data
            let product = formatTemplate(response);

            // Append the product to the wrapper element
            wrapper.appendChild(product);

            // Remove first element from the array
            productHandleQueue.shift();

            // Increment shown
            shown++;

            // Recursively call function
            moveAlong();
          })
          .catch((error) => {
            // Log error
            console.log(error.message);
            // Remove first product from the array from the cookie
            cookie.remove(productHandleQueue[0]);
            productHandleQueue.shift();
            moveAlong();
          });
      } else {
        finalize();
      }
    };

    publicAPIs.showRecentlyViewed = function (params) {
      var params = params || {};

      // Update defaults.
      config = Object.assign(config, params);

      // Reset
      shown = 0;
      productHandleQueue = [];
      wrapper = null;
      template = null;

      // Read cookie.
      productHandleQueue = cookie.read();

      // Get the wrapper element
      wrapper = document.getElementById(config.wrapperId);

      // If we have any to show.
      if (config.howManyToShow && wrapper) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong();
      }
    };
    publicAPIs.getConfig = function () {
      return config;
    };
    publicAPIs.clearList = function () {
      cookie.destroy();
    };
    publicAPIs.getCount = function () {
      let productHandleQueue = cookie.read();
      return productHandleQueue.length;
    };

    publicAPIs.showRecentlyViewed(params);

    return publicAPIs;
  };

  return Constructor;
})();

Shopify.RecordViewedProducts = (function () {
  // default configs
  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 30,
    wrapperId: "recently-viewed-products",
    onComplete: null,
  };

  // array containing recently viewed products
  var productHandleQueue = [];

  // wrapper element that displays the products
  var wrapper = null;

  // variable to keep track of how many products have been shown
  var shown = 0;

  // Handle cookie related operations
  var cookie = {
    configuration: {
      expires: 90,
      path: "/",
      domain: window.location.hostname,
      sameSite: "none",
      secure: true,
    },
    name: "shopify_recently_viewed",
    write: function (recentlyViewed) {
      Cookies.set(this.name, recentlyViewed.join(" "), this.configuration);
    },
    read: function () {
      var recentlyViewed = [];
      var cookieValue = Cookies.get(this.name);
      if (cookieValue !== undefined && cookieValue !== "") {
        recentlyViewed = cookieValue.split(" ");
      }
      return recentlyViewed;
    },
    destroy: function () {
      Cookies.remove(this.name, null, this.configuration);
    },
    remove: function (productHandle) {
      var recentlyViewed = this.read();
      var position = recentlyViewed.indexOf(productHandle);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    },
  };

  return {
    getConfig: function () {
      return config;
    },
    clearList: function () {
      cookie.destroy();
    },
    getCount: function () {
      let productHandleQueue = cookie.read();
      return productHandleQueue.length;
    },
    recordRecentlyViewed: function (params) {
      var params = params || {};

      // Update defaults.
      config = Object.assign(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf("/products/") !== -1) {
        // What is the product handle on this page.
        var urlPathname = new URL(window.location).pathname;
        var urlArray = decodeURIComponent(urlPathname).split("/");
        var productHandle = urlArray[urlArray.indexOf("products") + 1];
        if (!productHandle) {
          console.log("Error, no product handle found.");
          return false;
        }

        // In what position is that product in memory.
        var position = recentlyViewed.indexOf(productHandle);

        // If not in memory. (product handle was not found in the recentlyv)
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);

          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(
            0,
            config.howManyToStoreInMemory
          );
        } else {
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);
      }
    },
  };
})();


function initArticleSlideFlickity() {
  // Run only on body.template-article
  if (!document.body.classList.contains("template-article")) return;

  const container = document.querySelector(".article-slideshow");
  if (!container) return;

  if (container.classList.contains("flickity-enabled")) return;

  imagesLoaded(container, function () {
    setTimeout(() => {
      const flkty = new Flickity(container, {
        cellSelector: "article",
        cellAlign: "left",
        contain: true,
        pageDots: true,
        autoPlay: false,
        groupCells: "100%",
        prevNextButtons: false,
      });

      flkty.resize();
    }, 100);
  });
}
// ARTICLE SLIDESHOW

document.addEventListener("DOMContentLoaded", initArticleSlideFlickity);
document.addEventListener("shopify:section:load", initArticleSlideFlickity);


document.addEventListener("DOMContentLoaded", function () {
  // Select the target container
  const newsletterBlock = document.querySelector(
    ".section-footer .top-footer .footer-block.block--newsletter"
  );

  if (newsletterBlock) {
    const socialContainer = document.createElement("div");
    socialContainer.className = "footer-social-links-container";

    const link1 = document.createElement("a");
    link1.setAttribute("target", "_blank")
    link1.href = "https://www.instagram.com/nomaka.official/";
    link1.textContent = "INSTAGRAM";
    const link2 = document.createElement("a");
    link2.setAttribute("target", "_blank")
    link2.href = "https://ch.linkedin.com/company/nomaka-ag";
    link2.textContent = "LINKEDIN";

    socialContainer.appendChild(link1);
    socialContainer.appendChild(link2);

    newsletterBlock.appendChild(socialContainer);
  }
});

const header = document.querySelector("body:not(#nomaka) .header-section--nomaka");
const headerCart = document.querySelector("aside.mini-cart--nomaka");

const toggleByScroll = (el, scrollTop) => {
  if (!el) return;
  if (scrollTop > 10) {
    el.classList.add("show");
  } else {
    el.classList.remove("show");
  }
};

window.addEventListener(
  "scroll",
  () => {
    const scrollTop = window.scrollY || window.pageYOffset;
    toggleByScroll(header, scrollTop);
    toggleByScroll(headerCart, scrollTop);
  },
  { passive: true }
);


document.addEventListener(
  "scroll",
  (e) => {
    const scroller = e.target;

    if (header && (scroller === header || header.contains(scroller))) return;
    if (headerCart && (scroller === headerCart || headerCart.contains(scroller))) return;

    if (scroller.scrollHeight > scroller.clientHeight) {
      toggleByScroll(header, scroller.scrollTop);
      toggleByScroll(headerCart, scroller.scrollTop);
    }
  },
  { capture: true, passive: true }
);


// nomaka banner hide on scroll efect
(function () {
  const KEY = "nomakaBannerDismissedAt"; // store timestamp of dismissal
  const INTERVAL = 4 * 60 * 1000; // 4 minutes in ms
  const BANNER_SEL = ".section-header__banners--nomaka";
  const LINK_SEL = ".section-header__banner-link";

  function shouldHide() {
    const raw = localStorage.getItem(KEY);
    const ts = raw ? parseInt(raw, 10) : 0;
    return ts && Date.now() - ts < INTERVAL;
  }

  function rememberDismissal() {
    try {
      localStorage.setItem(KEY, String(Date.now()));
    } catch (_) {}
  }

  function initNomakaBanner() {
    const banner = document.querySelector(BANNER_SEL);
    if (!banner) return;

    // Show / hide based on 4-min window
    if (shouldHide()) {
      banner.classList.add("hidden");
    } else {
      banner.classList.remove("hidden");
    }

    // Persist dismissal BEFORE navigation (capture phase).
    banner.addEventListener(
      "click",
      (e) => {
        if (e.target.closest(LINK_SEL)) {
          rememberDismissal();
          banner.style.display = "none";
        }
      },
      { capture: true }
    );

    // If you have a close button, also persist on that.
    const close = banner.querySelector(".announcement-bar__close");
    if (close) {
      close.addEventListener(
        "click",
        () => {
          rememberDismissal();
          banner.style.display = "none";
        },
        { capture: true }
      );
    }

    // Keyboard activation fallback for accessibility
    banner.addEventListener("keydown", (e) => {
      if ((e.key === "Enter" || e.key === " ") && e.target.closest(LINK_SEL)) {
        rememberDismissal();
        banner.style.display = "none";
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initNomakaBanner);
  } else {
    initNomakaBanner();
  }
})();

window.addEventListener('load', () => {
  const submitFormButton = document.querySelector(".footer-block__newsletter button[type='submit']")
  const error = document.querySelector(".footer-block__newsletter #contact-form-error")
  if(submitFormButton){
      const form = submitFormButton.closest('form')
      const email = form.querySelector('input[name="contact[email]"]')
      submitFormButton.addEventListener('click', (evt) => {
        evt.preventDefault();
          window.dataLayer = window.dataLayer || [];
          const emailValue = email?.value
    if(!emailValue){
      error.textContent = "Please enter a valid email address.";
      return
    }
    if (email.validity.typeMismatch) {
      error.textContent = "Please enter a valid email address.";
      return
    } else {
      error.textContent = "";
    }
    

  window.dataLayer.push({
    event: "email_submit",
    form_id: form?.id,
    form_action: form?.action,
    email: emailValue || undefined, 
  });
  setTimeout(()=>{form.submit()},2000)
        
      })
  }
})
